<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UZO48s/media/FC-9798891552876.jpg?1721600811918" alt="This image is the cover for the book After Words"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">After Words
      </h1>
      <p class="bookDescription body article font2">
        <p>Five friends embark on a cross-country train journey in America, unaware they are on the cusp of the COVID pandemic. Their voyage is marked by a captivating word game, where each draws a card corresponding to a letter and shares an experience inspired by an undisclosed word. The game, simple in its premise, becomes a gateway to unexpected memories and stories, evolving in real-time. As each friend takes their turn, readers are invited to guess the hidden word, immersing themselves in the narrative as if seated among the group.</p><p>This engaging game sets the stage for a tapestry of associations and reminiscences, pushing the boundaries of what can be spoken. The novel follows each character over three years, capturing their unique circumstances and experiences during the pandemic across various locales and moments. Readers get a new perspective through their lived challenges, joys, and dreams. </p><p>As the friends reunite for a second journey on a different route post-pandemic, the profound impacts of both the global event and the word game itself come to light. The narrative, divided into three parts, offers a looping portrayal of time: before, during, and after the pandemic.</p><p>Rich with atmospheric and lyrical passages, this novel invites its readers to delve into the intricate world of language, exploring the mysterious and transformative power of words.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Annie G Rogers
      </h2>
      
      <p class="authorDescription body article"><p style='margin:0mm;font-size:16px;font-family:"Times",serif;text-align:justify;'><span style='font-size:15px;font-family:"Times New Roman",serif;color:black;background:white;'>Annie G. Rogers, Ph.D., is a writer, psychoanalyst, and printmaker. She is Analyst of the School at the Lacanian School of Psychoanalysis, where she teaches and supervises. She was a professor for much of her professional life, serving on faculties at Harvard University and Hampshire College. Dr. Rogers has published short fiction and poetry as well as three non-fiction clinical books: <em>A Shining Affliction: A Story of Harm and Healing in Psychotherapy (1995)</em>; <em>The Unsayable: The Hidden Language of Trauma (2005);</em> and <em>Incandescent Alphabets: Psychosis and the Enigma of Language (2016)</em>. Currently, she makes prints and artist&rsquo;s books at Zea Mays Printmaking in Florence, Massachusetts, and is compiling a book of poetry, <em>Becoming Bird. </em>She divides her time between Western Massachusetts and Lismore, Ireland.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69a0a9fe